module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": _vm.isMobileSize ? '98%' : '70%'
    },
    model: {
      value: (_vm.mostrarModal),
      callback: function($$v) {
        _vm.mostrarModal = $$v
      },
      expression: "mostrarModal"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "video-wrapper"
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": _vm.videoUrl,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-760d38d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/popup/VideoPopup.vue
// module id = 561
// module chunks = 2